import { FC } from 'react';
import { Layout } from '../../../queries/ats/layout/types';
import { Highlights } from '../../../queries/ats/titles/types/search';
import { Title } from '../../../queries/ats/titles/types/title';
import { AtsAsset } from '../../ATS/ats-asset';

interface SearchResultViewProps {
  title: Title;
  highlights: Highlights;
  query: string;
}

const SearchResultViewItem: FC<SearchResultViewProps> = ({ title, highlights, query }) => {
  return (
    <AtsAsset
      item={{
        id: title.masterId,
        title: title,
        type: 'title',
        slug: title.slug,
        name: title.titleName,
        image: '',
        icon: '',
        pageStyle: Layout.PageViewStyleType.SWIMLANE,
        params: null,
      }}
      pattern="wide"
      matchTitle={query}
    />
  );
};

export default SearchResultViewItem;
